import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { processRbiCouponIssue } from '../../../../../actions/tools/RBIActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTRBIIssueCouponThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRbiCouponIssue());

  return (
    <DTCopyTextSendMacroView
      buttonText={'ISSUE COUPON'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to issue a coupon and copy the response to the text box'}
      customErrorMessage={'Error issuing the coupon. Please try again later.'}
    />
  );
};

export default withConfirmation(DTRBIIssueCouponThenSendMacroNode);
